import { MouseEventHandler } from 'react';
import { Button, ButtonProps, Icon, IconName } from '../../../../atoms';

export function OutletHeaderBackButton({
  text,
  onBack,
  ...rest
}: ButtonProps & {
  text?: string;
  onBack: MouseEventHandler<HTMLButtonElement> | undefined;
}): JSX.Element {
  return (
    <Button
      onClick={onBack}
      leftIcon={<Icon w="18px" h="18px" name={IconName.ArrowBack} />}
      p="0"
      variant="tertiary"
      {...rest}
    >
      {text}
    </Button>
  );
}
